import React, {useEffect} from "react";
import {useSelector} from "react-redux";
import {CentredLoader} from "../elements/Loader";
import {log} from "../../logging/logEvent";
import styled from "styled-components";
import PageHeading from "../elements/PageHeading";
import {Link} from "react-router-dom";
import {CSS_GE_L, CSS_GE_M, CSS_GE_S, CSS_GE_XL} from "./breakpoints";

const HelpVideosGallery = ({}) => {
    const helpVideos = useSelector(state => state.helpVideos)
    useEffect(() => {
        log("PageComponentMounted", {page: "HelpVideosGallery"})
    }, []);

    if (!helpVideos.videos) {
        return <div style={{padding: 20}}><CentredLoader/></div>;
    }

    return (
        <div>
            <GalleryTitle>Video guides</GalleryTitle>
            <GalleryContainer>
                <GalleryMenu>
                    {helpVideos.videos.map(video => {
                        const picture = video.pictures.find(it => it.width === 960 && it.height === 540)
                        return (
                            <li key={video.uri}>
                                <Link to={`/help/video/${video.uri.replace(/^\/videos\//, "")}`}>
                                    <img src={picture.link} alt={video.name}/>
                                    <div className="video-name">
                                        {video.name}
                                    </div>
                                </Link>
                            </li>
                        )
                    })}
                </GalleryMenu>
            </GalleryContainer>
        </div>
    )
}

const GalleryTitle = styled(PageHeading)`
  padding-left: 18px;
  padding-top: 30px;
  padding-bottom: 30px;
`;

const GalleryContainer = styled.div`
  margin: 0 auto;
  max-width: 1600px;
  padding: 0 24px;
`

const videoItemGapLarge = 12
const videoItemGapMedium = (videoItemGapLarge / 3) * 2 // 8
const videoItemGapSmall = videoItemGapLarge / 2 // 6

const GalleryMenu = styled.menu`
  display: flex;
  flex-flow: row wrap;
  justify-content: flex-start;
  padding: 0;

  @media (min-width: 320px) {
    // XS
    margin: 0 -${videoItemGapSmall}px;
  }

  @media (min-width: 814px) {
    // M
    margin: 0 -${videoItemGapMedium}px;
  }

  @media (min-width: 1400px) {
    // XL
    margin: 0 -${videoItemGapLarge}px;
  }

  > li {
    list-style-type: none;
    display: flex;
    flex-shrink: 0;
    flex-grow: 0;

    box-sizing: border-box;

    // XS by default
    flex-basis: calc(100% - ${videoItemGapSmall * 2}px);
    margin: 0 ${videoItemGapSmall}px;

    margin-bottom: 24px;

    @media (${CSS_GE_S}) {
      flex-basis: calc(50% - ${videoItemGapSmall * 2}px);
      margin: 0 ${videoItemGapSmall}px;

      margin-bottom: 32px;
    }

    @media (${CSS_GE_M}) {
      flex-basis: calc(50% - ${videoItemGapMedium * 2}px);
      margin: 0 ${videoItemGapMedium}px;

      margin-bottom: 32px;
    }

    @media (${CSS_GE_L}) {
      flex-basis: calc(33% - ${videoItemGapMedium * 2}px);
      margin: 0 ${videoItemGapMedium}px;

      margin-bottom: 32px;
    }

    @media (${CSS_GE_XL}) {
      flex-basis: calc(25% - ${videoItemGapLarge * 2}px);
      margin: 0 ${videoItemGapLarge}px;

      margin-bottom: 40px;
    }

    img {
      width: 100%;
    }

    .video-name {
      font-weight: bold;
      font-size: 18px;
      padding: 5px 0;
    }
  }
`;

export default HelpVideosGallery
